import { render } from "./Coordonnees.vue?vue&type=template&id=ad4b754c"
import script from "./Coordonnees.vue?vue&type=script&lang=js"
export * from "./Coordonnees.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__